import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SkeletonGroupDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    status: {
        pointerEvents: "none",
        position: "absolute",
        overflow: "hidden",
        ...webStyle({
            clipPath: "inset(50%)",
            whiteSpace: "nowrap"
        })
    }
});

export const useStyles = ({
    borders
}: SkeletonGroupDynamicStyleType) => {
    const styles = {
        status: {
            height: borders.line,
            width: borders.line
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
